import { GVCookiesLgpdAlert } from '../commons/components/gv-cookie-lgpd-alert';

export class PagamentoAcessoController {
    constructor() {
        new GVCookiesLgpdAlert();
    }
}

new PagamentoAcessoController();